/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import {
  Dashboard,
  PermContactCalendar,
  BusinessCenter,
  LibraryAddCheck,
  LibraryAdd,
  Map
} from "@material-ui/icons";

import ContactPerson from "views/Recyclers/ContactPerson";
import MyRegistration from "views/Projects/MyRegistration";
import Projects from "views/Dashboard/Projects";
import Have from "views/Projects/Have";
import Need from "views/Projects/Need";
import MapForm2Data from "views/Maps/MapForm2Data";

const dashboardRoutes = [
  {
    id: 0,
    subId: "",
    path: "/dashboard",
    name: "Inicio",
    rtlName: "لوحة القيادة",
    icon: Dashboard,
    component: Projects,
    layout: "/adminprojects",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/myregistration",
    name: "Mi Registro",
    rtlName: "لوحة القيادة",
    icon: BusinessCenter,
    component: MyRegistration,
    layout: "/adminprojects",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/have",
    name: "Recursos que Tengo",
    rtlName: "لوحة القيادة",
    icon: LibraryAddCheck,
    component: Have,
    layout: "/adminprojects",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/need",
    name: "Recursos que Necesito",
    rtlName: "لوحة القيادة",
    icon: LibraryAdd,
    component: Need,
    layout: "/adminprojects",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/contactperson",
    name: "Contacto",
    rtlName: "لوحة القيادة",
    icon: PermContactCalendar,
    component: ContactPerson,
    layout: "/adminprojects",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/mapallregistration",
    name: "Mapa",
    rtlName: "لوحة القيادة",
    icon: Map,
    component: MapForm2Data,
    layout: "/adminprojects",
    submenu: [],
  },
];

export default dashboardRoutes;
